import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageUrlService } from '@nx-ng/services/image-url.service';
import { MapModalInterface } from '../models';

@Component({
  selector: 'nx-ng-map-modal',
  templateUrl: './map-modal.component.html',
})
export class MapModalComponent implements OnInit {
  title = '';
  imageUrl = '';
  imageAltText = '';

  constructor(
    public dialogRef: MatDialogRef<MapModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MapModalInterface,
    public imageUrlService: ImageUrlService
  ) {}

  ngOnInit(): void {
    this.title = this.data?.title;
    this.imageUrl = this.data?.imageUrl;
    this.imageAltText = this.data?.imageAltText;
  }
}
